export default "__VITE_ASSET__BaWpYlX5__"